/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAddressDto
 */
export interface CreateAddressDto {
    /**
     * Première ligne d'adresse
     * @type {string}
     * @memberof CreateAddressDto
     */
    line1: string;
    /**
     * Deuxième ligne d'adresse
     * @type {string}
     * @memberof CreateAddressDto
     */
    line2: string;
    /**
     * Troisième ligne d'adresse (optionnelle)
     * @type {string}
     * @memberof CreateAddressDto
     */
    line3?: string | null;
    /**
     * Code postal
     * @type {string}
     * @memberof CreateAddressDto
     */
    zipCode: string;
    /**
     * Ville
     * @type {string}
     * @memberof CreateAddressDto
     */
    city: string;
    /**
     * Pays
     * @type {string}
     * @memberof CreateAddressDto
     */
    country: string;
    /**
     * Adresse formatée complète
     * @type {string}
     * @memberof CreateAddressDto
     */
    formattedAddress?: string | null;
    /**
     * Latitude géographique
     * @type {number}
     * @memberof CreateAddressDto
     */
    latitude?: number;
    /**
     * Longitude géographique
     * @type {number}
     * @memberof CreateAddressDto
     */
    longitude?: number;
    /**
     * Identifiant Google Place
     * @type {string}
     * @memberof CreateAddressDto
     */
    googlePlaceId?: string | null;
}

/**
 * Check if a given object implements the CreateAddressDto interface.
 */
export function instanceOfCreateAddressDto(value: object): value is CreateAddressDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('line2' in value) || value['line2'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreateAddressDtoFromJSON(json: any): CreateAddressDto {
    return CreateAddressDtoFromJSONTyped(json, false);
}

export function CreateAddressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAddressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'],
        'line3': json['line3'] == null ? undefined : json['line3'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
    };
}

export function CreateAddressDtoToJSON(json: any): CreateAddressDto {
    return CreateAddressDtoToJSONTyped(json, false);
}

export function CreateAddressDtoToJSONTyped(value?: CreateAddressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'line3': value['line3'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'googlePlaceId': value['googlePlaceId'],
    };
}

